<template>
    <div class="row">
        <div class="col_12">
            <div class="card no_border">
                <div class="card-header">
                    <div class="card-title">{{ $t('sidebar.thinkingSkill.thinkingSkill') }}</div>
                </div>
                <div class="card-body pl_0 pr_0">
                    <div class="row">
                        <div class="col_12">
                            <div class="custom_tabs">
                                <nav class="tabs">
                                    <ul class="">
                                        <li href="#topSolutions" :class="{'active': activeTab == 1}" @click.prevent="changeTab(1)">{{ $t('sidebar.thinkingSkill.topSolutions') }}</li>
                                        <li href="#thinkingAbility" :class="{'active': activeTab == 2}" @click.prevent="changeTab(2)">{{ $t('sidebar.thinkingSkill.thinkingAbility') }}</li>
                                        <li href="#examinations" :class="{'active': activeTab == 3}" @click.prevent="changeTab(3)">{{ $t('sidebar.thinkingSkill.examinations') }}</li>
                                    </ul>
                                </nav>
                                <div class="tab_content_wrapper">
                                    <div id="topSolutions" class="tab_content" :class="{'show': activeTab == 1}">
                                        <top-solution v-if="activeTab == 1"></top-solution>
                                    </div>
                    
                                    <div id="thinkingAbility" class="tab_content" :class="{'show': activeTab == 2}">
                                        <thinking-ability v-if="activeTab == 2"></thinking-ability>
                                    </div>
                    
                                    <div id="examinations" class="tab_content" :class="{'show': activeTab == 3}">
                                        <examination v-if="activeTab == 3"></examination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopSolution from './components/TopSolution'
    import ThinkingAbility from './components/ThinkingAbility'
    import Examination from './components/Examination'

    export default {
        name: 'thinking-skill-list',
        components: {
            TopSolution,
            ThinkingAbility,
            Examination,
        },
        data() {
            return {
                activeTab:1
            }
        },
        methods: {
            changeTab(step){
                this.activeTab = step
            }
        }
    }
</script>